import axiosInstance from "../config/axiosInterceptor";

export async function postCommand(nodeId, deviceId, cmdKey, cmdStr, params = []) {
  const commandData = {
    nodeId,
    deviceId,
    cmdKey,
    cmdStr,
    params,
  };

  return await axiosInstance.post("/api/Command", commandData);
}

export async function getCommandResponse(nodeId, deviceId, cmdKey) {
  const commandData = {
    nodeId,
    deviceId, 
    cmdKey,
  };

  return await axiosInstance.post("/api/Command/GetCommandResponse", commandData);
}
